const RedBorderButton = ({label, onClick}) => {
    return (
        <button type="button" className="button red-border-button" onClick={onClick}>{label}</button>
    );
}

export default RedBorderButton;